import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import moment from "moment";
import { Button, Col, Row } from "reactstrap";
import LabeledValue from "./LabeledValue";
import * as SourceInfo from "../api/SourceInfo";
import "./SignRequestInfoData.scss";
import * as appUtils from "../utils/appUtils";
import { Icon } from "@mc/mc-legacy";
import SeznamPriloh from "./SeznamPriloh";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import {Modal, Popover, Position} from "@mc/react-core";
import Linkify from "../utils/parseUrl";

/**
 * Meta informace o požadavku
 */

class SignRequestInfoData extends PureComponent {
  static propTypes = {
    signRequest: PropTypes.object.isRequired,
    showDeadlineExpired: PropTypes.bool,
  };
  static defaultProps = {
    showDeadlineExpired: false,
  };
  formatDate = (date) => {
    return moment(date).format("D.M.YYYY");
  };

  render() {
    const { showDeadlineExpired, signRequest } = this.props;
    const deadlineExpired =
      showDeadlineExpired && signRequest.signUntil && moment().diff(moment(signRequest.signUntil)) > 0;
    let podepisujici = signRequest.pracovnikSignList.map((pracovnik) => appUtils.getPracovnikLabel(pracovnik));
    podepisujici = podepisujici.join(", ");

    return (
        <>
      <Row noGutters className={"mt-2 sign-request-info-data"}>

        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue label="Podepisující" value={podepisujici} />
        </Col>

        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue
            label="Zdroj"
            title={signRequest.sourceOrganization && signRequest.sourceOrganization}
            value={signRequest.source && SourceInfo.getCaption(signRequest.source)}
          />
        </Col>
        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue label="Vloženo" value={this.formatDate(signRequest.created)} />
        </Col>
        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue
            className={deadlineExpired && "deadlineExpired"}
            label="Termín"
            value={signRequest.signUntil ? this.formatDate(signRequest.signUntil) : "-"}
          />
        </Col>

      </Row>
            {signRequest.description&& <Row className={"mt-2 mb-2 pl-4 pr-4"}>
                <Col xs={10}>
                    <Popover
                        className={"custom-popover"}
                        minimal
                        content={
                            <div className={"p-2 max-popover-width"}>
                                <Linkify text={signRequest.description}/>
                            </div>
                        }
                        position={Position.BOTTOM_LEFT}
                    >
                        <Linkify linkAtStartOnly={true} text={signRequest.description} style={{cursor: "pointer"}}
                                 className={"truncate-text"}/>
                    </Popover>
                </Col>
            </Row>}
        </>
    );
  }
}

export default SignRequestInfoData;
